import React from 'react';
import { motion } from 'framer-motion';
import { SectionMarker } from './SectionMarker';
export function WhatChangesSection() {
  const testimonials = [{
    name: 'Marta',
    quote: 'Volví a dormir completa después de años.'
  }, {
    name: 'Ana',
    quote: 'Dejé de despertarme a las 3 AM en la primera semana.'
  }, {
    name: 'Lucía',
    quote: 'Entendí lo que me pasaba y todo cambió.'
  }];
  return <section className="w-full bg-navy-dark py-10 md:py-14" data-id="element-253">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-254">
        {/* Imagina esta noche */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-255">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-256">
            <SectionMarker data-id="element-257" />
            <span className="text-cream-muted text-sm uppercase tracking-wider" data-id="element-258">
              Transformación
            </span>
          </div>

          <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl font-bold text-cream mb-8" data-id="element-259">
            Imagina esta noche…
          </h2>

          <div className="space-y-4 text-lg text-cream-muted leading-relaxed max-w-2xl mx-auto" data-id="element-260">
            <p data-id="element-261">te despiertas… pero algo es diferente…</p>
            <p className="text-cream" data-id="element-262">
              tu cuerpo no entra en ansiedad… tu mente no se acelera…
            </p>
            <p data-id="element-263">respiras… te relajas…</p>
            <p className="text-xl text-amber font-medium mt-4" data-id="element-264">
              y vuelves a dormir.
            </p>
          </div>
        </motion.div>

        {/* Social Proof */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mb-12" data-id="element-265">
          <div className="space-y-4 max-w-xl mx-auto" data-id="element-266">
            {testimonials.map((t, index) => <motion.div key={t.name} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1 * index
          }} className="p-5 bg-navy-darkest/50 border border-cream-muted/10 rounded-lg" data-id="element-267">
                <p className="text-cream italic" data-id="element-268">"{t.quote}"</p>
                <p className="text-amber text-sm font-medium mt-2" data-id="element-269">
                  — {t.name}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}